const API_BASE = process.env.NEXT_PUBLIC_API_BASE_URL || process.env.NEXT_API_PROXY_TARGET || ''

export function getMediaUrl(objectKey?: string | null) {
  if (!objectKey) return ''
  const base = API_BASE ? API_BASE.replace(/\/$/, '') : ''
  return `${base}/api/public/media/${encodeURIComponent(objectKey)}`
}
